import { render, staticRenderFns } from "./_CarouselItem.vue?vue&type=template&id=460ffd8b&scoped=true&"
import script from "./_CarouselItem.vue?vue&type=script&lang=js&"
export * from "./_CarouselItem.vue?vue&type=script&lang=js&"
import style0 from "./_CarouselItem.vue?vue&type=style&index=0&id=460ffd8b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460ffd8b",
  null
  
)

export default component.exports